import React, { useEffect, useState } from 'react';
import T from 'prop-types';
// components
import QuestionRow from '../QuestionRow';
import CategoryRollUp from '../CategoryRollUp';
import { UnmountClosed } from 'react-collapse';
// utils
import classnames from 'classnames/bind';
import {
  OPEN_SVR_QUESTION_EVENT,
  scrollAndHighlightQuestion,
} from 'containers/Report/utils/reportActivityEvents';
import { shouldRevealSVRCategoryQuestions } from 'utils/SVRHelper';
// styles
import styles from './CategoryRow.module.scss';

const cn = classnames.bind(styles);

const CategoryRow = ({ category, categoryIndex, isDraft, categoryPassAll }) => {
  // Categories answered individually or left incomplete start revealed,
  // untouched or fully passed ones stay behind the roll-up.
  // With pass-all off there is no roll-up, so categories start collapsed as before EPN-2989
  const [isOpened, setIsOpened] = useState(
    () => !!isDraft && !!categoryPassAll && shouldRevealSVRCategoryQuestions(category)
  );

  useEffect(() => {
    const handler = (event) => {
      const questionId = event.detail?.questionId;
      if (!questionId) return;
      const belongsToCategory = category.svr_questions.some(
        (q) => String(q.id) === String(questionId)
      );
      if (!belongsToCategory) return;
      setIsOpened(true);
      scrollAndHighlightQuestion(questionId);
    };
    window.addEventListener(OPEN_SVR_QUESTION_EVENT, handler);
    return () => window.removeEventListener(OPEN_SVR_QUESTION_EVENT, handler);
  }, [category]);
  const allQuestionsCount = category.svr_questions.length;
  const answeredQuestionsCount = category.svr_questions.filter(({ answer }) => answer?.value).length;

  const questionRenderer = (question, index) => (
    <QuestionRow categoryIndex={categoryIndex} questionIndex={index} question={question} key={index} />
  );

  return (
    <div className={cn('category-row')}>
      {/* header */}
      <div className={cn('category-header')} onClick={() => setIsOpened(!isOpened)}>
        <div>
          <span className="semibold">{category.name}</span>
          &nbsp;
          <span>{answeredQuestionsCount}/{allQuestionsCount}</span>
        </div>
        <i className={cn('fa fa-angle-right-btb', 'collapse-icon', { opened: isOpened })} />
      </div>
      {/* roll-up confirmation */}
      <CategoryRollUp
        category={category}
        categoryIndex={categoryIndex}
        areQuestionsVisible={isOpened}
        onConfirm={(hasRemainingQuestions) => setIsOpened(hasRemainingQuestions)}
        onDecline={() => setIsOpened(true)}
      />
      {/* content */}
      <UnmountClosed hasNestedCollapse isOpened={isOpened}>
        {category.svr_questions.map(questionRenderer)}
      </UnmountClosed>
    </div>
  );
};

CategoryRow.propTypes = {
  category: T.object.isRequired,
  categoryIndex: T.number.isRequired,
  isDraft: T.bool,
  categoryPassAll: T.bool,
};

export default CategoryRow;
